import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmDeletion = ({ show, onConfirm, onHide, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered contentClassName="bg-dark text-white">
      <Modal.Header closeButton closeVariant="white" className="border-secondary">
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || 'Are you sure you want to delete this item?'}</p>
      </Modal.Body>
      <Modal.Footer className="border-secondary">
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeletion;
